export const hasQueryString = (urlString: string): boolean => {
  try {
    const url = new URL(urlString)
    return url.search.length > 0
  } catch (error) {
    return false
  }
}
